import { render, staticRenderFns } from "./trash-paper-restore.html?vue&type=template&id=044a2fd8&scoped=true&"
import script from "./trash-paper-restore.js?vue&type=script&lang=js&"
export * from "./trash-paper-restore.js?vue&type=script&lang=js&"
import style0 from "./trash-paper-restore.scss?vue&type=style&index=0&id=044a2fd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044a2fd8",
  null
  
)

export default component.exports